var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Slider'),_c('div',{staticStyle:{"background":"#fff"}},[_c('Activity')],1),_c('Implantation'),_c('GazOpen'),_c('Bout'),_c('Estimation'),_c('Dg'),_c('News'),_c('Partenaire')],1)}
var staticRenderFns = []

export { render, staticRenderFns }